var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ("ee-select-box ee-select-box--" + _vm.size),
    style: ({
      width: (_vm.width + "px")
    }),
    on: {
      "mouseleave": function($event) {
        _vm.visible = false
      }
    }
  }, [_c('div', {
    staticClass: "ee-select-box__toggle",
    on: {
      "click": function($event) {
        _vm.visible = !_vm.visible
      }
    }
  }, [_vm._v("\n    " + _vm._s(typeof _vm.current === 'string' ? _vm.current : _vm.current.text)), _c('i', {
    staticClass: "text-icon icon-yzm"
  })]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "ee-select-box__content"
  }, _vm._l((_vm.dataSource), function(item) {
    return _c('li', {
      class: {
        active: _vm.value === item || _vm.value === item.value
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.handleSelect(item)
        }
      }
    }, [_vm._v(_vm._s(typeof item === 'string' ? item : item.text))])])
  }))])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e345b25","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/packages/select/SelectBox.vue
// module id = 558
// module chunks = 13